import Axios from "axios";
import router from "../router";
import environment from "@/environment";
import { RequestInterceptor } from "./request.interceptor";

export class HttpInterceptors {
	axios;

	constructor () {
		const interceptor = new RequestInterceptor();
		this.axios = Axios.create({ baseURL: `${environment.API}/v1` });
		this.axios.interceptors.request.use(interceptor.addAuthorizationHeader);
		this.axios.interceptors.response.use(
			response => response,
			error => {
				switch (error.response.status) {
					case 401: // Usuário não possui o nível de acesso necessário
						router.push("/forbidden");
						break;
					case 402: // Pagamento requerido
						router.push({ path: "/renovar"});
						break;
					case 403: // Sessao invalida
						router.push("/forbidden");
						break;
				}

				return Promise.reject(error);
			}
		);
	}
}